import { Row, Skeleton, Col, Flex } from "antd";
import { Loader } from "components/Loader";
import useMediaQuery from "hooks/useMediaQuery";
import { ScreenSize } from "models/screenSize";
// Define props for customizable card

export const PageLoader: React.FC = (props) => {
  const isMobile = !useMediaQuery(ScreenSize.md);
  return isMobile ? (
    <div style={{ padding: 15 }}>
      <Flex gap="middle" vertical>
        <Row
          gutter={[
            { xs: 13, sm: 20 },
            { xs: 13, sm: 40 },
          ]}
          style={{ marginBottom: 10 }}
        >
          {[...Array(3)].map((_, colIndex) => (
            <Col key={colIndex} xs={8} sm={8} md={8} lg={8} xl={8} xxl={6}>
              <Skeleton.Button active size="default" shape="square" block />
            </Col>
          ))}
        </Row>
        <Skeleton.Input
          active={true}
          size="small"
          block={true}
          style={{ marginBottom: 10 }}
        />
        <Skeleton.Node active={true} style={{ width: "100%", height: 100 }} />
        <Skeleton.Node
          active={true}
          style={{ width: "100%", height: 100, marginBottom: 10 }}
        />

        <Row align="middle" gutter={16} style={{ marginBottom: 10 }}>
          <Col flex="auto">
            <Skeleton.Input
              active
              size="small"
              block
              style={{ width: "100%" }}
            />
          </Col>
          <Col>
            <Skeleton.Avatar active size="default" shape="circle" />
          </Col>
        </Row>
        <Skeleton active />
        <Skeleton active />
      </Flex>
    </div>
  ) : (
    <Loader loaderText="loading.." />
  );
};
